import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { ModifierGroupFormItem } from "./ModifierGroupForm"
import type { CategoryModifierGroup, CategoryModifierGroupOverride } from "../../../../graphql/types"

export const MODIFIER_GROUP_FORM_SUBMITTED = "modifier-group/form/submitted"

export const modifierGroupFormSubmitted = (
    oldValue: Maybe<ModifierGroupFormItem>,
    newValue: ModifierGroupFormItem
) => ({
    type: MODIFIER_GROUP_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const MODIFIER_GROUP_DATA_CREATED = "modifier-group-data-created"
export const modifierGroupDataCreated = (oldValue: Maybe<ModifierGroupFormItem>, newValue: ModifierGroupFormItem) => ({
    type: MODIFIER_GROUP_DATA_CREATED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const MODIFIER_GROUP_DATA_UPDATED = "modifier-group-data-updated"
export const modifierGroupDataUpdated = (oldValue: Maybe<ModifierGroupFormItem>, newValue: ModifierGroupFormItem) => ({
    type: MODIFIER_GROUP_DATA_UPDATED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_MODIFIER_GROUP_CLICKED = "modifier-group/delete/clicked"
export const deleteModifierGroupClicked = (id: string) => ({
    type: DELETE_MODIFIER_GROUP_CLICKED,
    payload: {
        modifierGroupId: id,
    },
})

export const CLOSE_MODIFIER_GROUP_FORM_CLICKED = "modifier-group/close/clicked"
export const closeModifierGroupFormClicked = () => ({
    type: CLOSE_MODIFIER_GROUP_FORM_CLICKED,
})

// Api actions
export const MODIFIER_GROUP_SAVE_SUCCESS = "modifierGroup/save/success"
export const modifierGroupSaveSuccess = (data: CategoryModifierGroup) => ({
    type: MODIFIER_GROUP_SAVE_SUCCESS,
    payload: {
        data: data,
    },
})

export const MODIFIER_GROUP_LOCATION_SAVE_SUCCESS = "modifierGroup/location/save/success"
export const modifierGroupLocationSaveSuccess = (
    data: Maybe<CategoryModifierGroupOverride>,
    id: string,
    locationId: string
) => ({
    type: MODIFIER_GROUP_LOCATION_SAVE_SUCCESS,
    payload: {
        data: data,
        id: id,
        locationId: locationId,
    },
})

export const MODIFIER_GROUP_LOCATION_SAVE_FAILURE = "modifierGroup/location/save/failure"

export const modifierGroupLocationSaveFailure = (error: any) => ({
    type: MODIFIER_GROUP_LOCATION_SAVE_FAILURE,
    payload: {
        error: error,
    },
})

export const MODIFIER_GROUPS_DELETED = "modifier-groups/deleted"
export const modifierGroupsDeleted = (ids: string[]) => ({
    type: MODIFIER_GROUPS_DELETED,
    payload: {
        ids: ids,
    },
})
